import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "row h-100" }
const _hoisted_8 = { class: "col h-100" }
const _hoisted_9 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_10 = { class: "form-check" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "row h-100" }
const _hoisted_13 = { class: "col h-100" }
const _hoisted_14 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_15 = { class: "form-check" }
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = { class: "row h-100" }
const _hoisted_18 = { class: "col h-100" }
const _hoisted_19 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_20 = { class: "form-check" }
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = { class: "row h-100" }
const _hoisted_23 = { class: "col h-100" }
const _hoisted_24 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_25 = { class: "form-check" }
const _hoisted_26 = { class: "col-sm-6" }
const _hoisted_27 = { class: "mb-3" }

import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { useProductGroupsStore } from '@/store/management/productGroupsStore';
import type { ProductGroup } from '@/store/management/productGroupsStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'productGroupsBasic',
  setup(__props) {

const productsGroupsAltLangModal = defineAsyncComponent(() => import('@/components/managementPages/productGroupsPages/productGroupsAltLangModal.vue'))

const productGroupsStore = useProductGroupsStore()

onMounted(() => {
    if (tempActiveProductGroup.value?.id) {
        compState.id = tempActiveProductGroup.value.id
        compState.name = tempActiveProductGroup.value.name
        compState.showOnMenu = tempActiveProductGroup.value.showOnMenu
        compState.displayOrder = tempActiveProductGroup.value.displayOrder
        compState.nonDiscountable = tempActiveProductGroup.value.nonDiscountable
        compState.nonSurchargeable = tempActiveProductGroup.value.nonSurchargeable
        compState.usedToRouteOrders = tempActiveProductGroup.value.usedToRouteOrders
        compState.altLangText = altDisplayText(tempActiveProductGroup.value.altDisplayLang)
    }
})

const compState = reactive({
    id: '',
    name: '',
    showOnMenu: false,
    displayOrder: 0,
    nonDiscountable: false,
    nonSurchargeable: false,
    usedToRouteOrders: false,
    altLangText: ''
})


const activeProductGroup = computed(() => {
    return productGroupsStore.getActiveProductGroup
})

const tempActiveProductGroup = computed(() => {
    return productGroupsStore.getTempActiveProductGroup
})

const activeProductGroupId = computed(() => {
    return productGroupsStore.getActiveProductGroupId
})

const altDisplayText = (langList: String[]) => {
    if (langList) {
        return langList.filter(lang => lang !== '').join('|')
    }
    return ''
}

watch(activeProductGroupId, (newVal) => {
    if (newVal) {
        const productGroup = activeProductGroup.value
        compState.id = productGroup.id
        compState.name = productGroup.name
        compState.showOnMenu = productGroup.showOnMenu
        compState.displayOrder = productGroup.displayOrder
        compState.nonDiscountable = productGroup.nonDiscountable
        compState.nonSurchargeable = productGroup.nonSurchargeable
        compState.usedToRouteOrders = productGroup.usedToRouteOrders
        compState.altLangText = altDisplayText(tempActiveProductGroup.value.altDisplayLang)
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productGroupsStore.setTempActiveProductGroup({
        ...tempActiveProductGroup.value,
        id: newVal.id,
        name: newVal.name,
        showOnMenu: newVal.showOnMenu,
        displayOrder: newVal.displayOrder,
        nonDiscountable: newVal.nonDiscountable,
        nonSurchargeable: newVal.nonSurchargeable,
        usedToRouteOrders: newVal.usedToRouteOrders,
    } as ProductGroup)
}, { deep: true });

const displayOrderIncrement = () => {
    compState.displayOrder++
}

const displayOrderDecrement = () => {
    if (compState.displayOrder > 0) {
        compState.displayOrder--
    }
}
const onEditAltLang = () => {
    compState.altLangText = altDisplayText(tempActiveProductGroup.value.altDisplayLang)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Group Name")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.name) = $event)),
            class: "form-control",
            type: "text",
            placeholder: "Name",
            maxlength: "32"
          }, null, 512), [
            [_vModelText, compState.name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[8] || (_cache[8] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Display Order")
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "number",
            placeholder: "Threshold",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.displayOrder) = $event))
          }, null, 512), [
            [_vModelText, compState.displayOrder]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-end-0",
            type: "button",
            onClick: displayOrderDecrement
          }, "-"),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-start-0",
            type: "button",
            onClick: displayOrderIncrement
          }, "+")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "show-on-menu",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.showOnMenu) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.showOnMenu]
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "show-on-menu"
                }, "Show on Menu", -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "used-to-route-orders",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.usedToRouteOrders) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.usedToRouteOrders]
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "used-to-route-orders"
                }, "Used to Route Orders", -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "service-check",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((compState.nonDiscountable) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.nonDiscountable]
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "service-check"
                }, "Non-Discountable", -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "surchargeable-check",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((compState.nonSurchargeable) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.nonSurchargeable]
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "surchargeable-check"
                }, "Non-Surchargeable", -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _cache[13] || (_cache[13] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Alternative Display Language")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "text",
            placeholder: "Alternative Display Language",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((compState.altLangText) = $event)),
            maxlength: "32",
            readonly: "",
            "data-bs-toggle": "modal",
            "data-original-title": "test",
            "data-bs-target": "#alt-lang-modal"
          }, null, 512), [
            [_vModelText, compState.altLangText]
          ])
        ])
      ])
    ]),
    _createVNode(_unref(productsGroupsAltLangModal), { onOnSave: onEditAltLang })
  ], 64))
}
}

})